/* Wanderth — hover de miniaturas de variante en grid de productos.
   Al pasar el mouse sobre un .grid-product__variant-thumb, mostramos la imagen
   de la variante en un overlay <img> que cubre la imagen principal. Si el
   overlay no existe aún en esa card, lo creamos lazy. Al salir, se oculta.

   Approach: overlay propio (.wanderth-variant-overlay) en lugar de reutilizar
   .grid-product__color-image del theme, para no depender de su renderizado
   (que sólo emite divs para variantes con imagen) y evitar conflictos con la
   imagen secundaria de hover ya existente. */
/* Wanderth — hover de miniaturas de variante en grid de productos.
   Versión 3.0 — Modificación directa del SRC de la imagen principal.
   Este enfoque evita conflictos con el hover nativo del tema. */
(function () {
  'use strict';

  const originalImageSources = new WeakMap();

  function storeOriginalImage(card, imageElement) {
    if (!originalImageSources.has(card)) {
      originalImageSources.set(card, {
        src: imageElement.src,
        srcset: imageElement.srcset,
      });
    }
  }

  function getVariantImage(thumb) {
    if (!thumb) {
      return null;
    }

    const dataImage = thumb.getAttribute('data-variant-image');
    if (dataImage) {
      return dataImage;
    }

    const thumbImg = thumb.querySelector('img');
    if (thumbImg && thumbImg.getAttribute('src')) {
      return thumbImg.getAttribute('src');
    }

    return null;
  }

  function handlePointerOver(event) {
    const thumb = event.target.closest('.grid-product__variant-thumb');
    if (!thumb || thumb.classList.contains('grid-product__variant-thumb--more')) {
      return;
    }

    const card = thumb.closest('.grid-product');
    const variantImage = getVariantImage(thumb);
    if (!card || !variantImage) {
      return;
    }

    const mainImage = card.querySelector('.wanderth-main-image');
    if (!mainImage) {
      return;
    }

    storeOriginalImage(card, mainImage);
    card.classList.add('wanderth-variant-active');

    mainImage.src = variantImage;
    mainImage.srcset = variantImage;
    if (mainImage.dataset) {
      mainImage.dataset.src = variantImage;
      mainImage.dataset.srcset = variantImage;
    }
  }

  function handlePointerOut(event) {
    const thumbsContainer = event.target.closest('.grid-product__variant-thumbs');
    if (!thumbsContainer) {
      return;
    }

    if (event.relatedTarget && thumbsContainer.contains(event.relatedTarget)) {
      return;
    }

    const card = thumbsContainer.closest('.grid-product');
    if (!card) {
      return;
    }

    const mainImage = card.querySelector('.wanderth-main-image');
    const originalSources = originalImageSources.get(card);

    if (mainImage && originalSources) {
      mainImage.src = originalSources.src;
      mainImage.srcset = originalSources.srcset;
      if (mainImage.dataset) {
        mainImage.dataset.src = originalSources.src;
        mainImage.dataset.srcset = originalSources.srcset;
      }
    }

    card.classList.remove('wanderth-variant-active');
  }

  document.addEventListener('pointerover', handlePointerOver);
  document.addEventListener('pointerout', handlePointerOut);
  document.addEventListener('mouseover', handlePointerOver);
  document.addEventListener('mouseout', handlePointerOut);

})();

/* Wanderth — flechas de scroll horizontal en las miniaturas del grid.
   Reemplaza el viejo overflow "+N" por navegación visual estilo Hawkers. */
(function () {
  'use strict';

  var STEP = 110;

  function updateArrows(scroller) {
    var track = scroller.querySelector('[data-thumbs-track]');
    var prev = scroller.querySelector('[data-thumbs-prev]');
    var next = scroller.querySelector('[data-thumbs-next]');
    if (!track || !prev || !next) return;

    var hasOverflow = track.scrollWidth > track.clientWidth + 1;
    if (!hasOverflow) {
      prev.hidden = true;
      next.hidden = true;
      return;
    }

    prev.hidden = false;
    next.hidden = false;
    prev.toggleAttribute('data-thumbs-disabled', track.scrollLeft <= 1);
    next.toggleAttribute('data-thumbs-disabled', track.scrollLeft >= track.scrollWidth - track.clientWidth - 1);
  }

  function initScroller(scroller) {
    if (scroller.dataset.thumbsInit === '1') return;
    scroller.dataset.thumbsInit = '1';

    var track = scroller.querySelector('[data-thumbs-track]');
    if (!track) return;

    var refresh = function () { updateArrows(scroller); };

    refresh();
    requestAnimationFrame(refresh);
    setTimeout(refresh, 250);
    setTimeout(refresh, 1000);

    track.addEventListener('scroll', refresh, { passive: true });
    window.addEventListener('resize', refresh);

    track.querySelectorAll('img').forEach(function (img) {
      if (img.complete) {
        refresh();
        return;
      }
      img.addEventListener('load', refresh, { once: true });
      img.addEventListener('error', refresh, { once: true });
    });

    if (window.ResizeObserver) {
      try { new ResizeObserver(refresh).observe(track); } catch (e) {}
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-thumbs-prev], [data-thumbs-next]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var scroller = btn.closest('[data-thumbs-scroller]');
    var track = scroller && scroller.querySelector('[data-thumbs-track]');
    if (!track) return;

    var dir = btn.hasAttribute('data-thumbs-next') ? 1 : -1;
    track.scrollBy({ left: dir * STEP, behavior: 'smooth' });
  });

  function bootAll() {
    document.querySelectorAll('[data-thumbs-scroller]').forEach(initScroller);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  // Debounce: el observer disparaba bootAll() (con lecturas de geometría) en CADA
  // mutación del DOM, causando reprocesamiento forzado (~64ms en Lighthouse).
  // Lo agrupamos en un solo frame y solo reaccionamos si se añadieron nodos.
  if (window.MutationObserver) {
    var bootScheduled = false;
    function scheduleBoot() {
      if (bootScheduled) return;
      bootScheduled = true;
      requestAnimationFrame(function () {
        bootScheduled = false;
        bootAll();
      });
    }
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
          scheduleBoot();
          return;
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
